<template>
    <div>
        <div class=" reveal">
            <div class="pa-5">
                <v-card
                        class="mx-auto rounded-xl pb-4 pr-4"
                        elevation="0"
                        min-height="200"
                        style="max-width: 800px"

                >

                    <v-list-item three-line class="pa-2">
                        <v-list-item-avatar
                                tile
                                size="100"
                                color="grey"
                                class="ml-5 rounded-lg"

                        >
                            <img src="../../../../assets/review-writing.png" alt="IVYED Writing Review"/>

                        </v-list-item-avatar>

                        <v-list-item-content class="pl-4 text-center">
                            <div class="font-weight-bold mt-3 mb-5"
                                 style="font-size: 20px; margin-bottom: 9px !important; font-family: S-CoreDream-5Medium">
                                English (Writing)
                                <!--                                <v-chip class="mt-2" small-->
                                <!--                                        style="font-weight: normal !important; font-size: 12px !important; background: #cb2d3e; background: linear-gradient(to bottom, #ef473a, #cb2d3e); color: #fafafa;">-->
                                <!--                                    입시정보-->
                                <!--                                </v-chip>-->

                            </div>
                            <!--                            <img style="width: 100%" src="https://i.postimg.cc/FRd4Hknq/review1.webp"/>-->


                            <!--                            <v-expansion-panels style="font-size: 17px;margin-left: -22px !important; margin-top: -10px !important;" flat>-->
                            <!--                                <v-expansion-panel >-->
                            <!--                                    <v-expansion-panel-header>-->
                            <!--                                        학교 선생님 수업 설명이 너무 부족해서 시작하게 됐어요. 동안 너무 힘들었는데..-->
                            <!--                                    </v-expansion-panel-header>-->
                            <!--                                    <v-expansion-panel-content>-->
                            <!--                                        학교 선생님 수업 설명이 너무 부족해서 시작하게 됐어요. 동안 너무 힘들었는데, 과외수업을 듣고 시작하고 난 뒤 부터 드디어 Java에 대해 이해하기 시작하고 퀴즈도 만점 받고 있어요. 수업시간 외에도 질문에 언제나 답해주시고 추가 관리까지 해주셔서 감사해요.-->
                            <!--                                    </v-expansion-panel-content>-->
                            <!--                                </v-expansion-panel>-->
                            <!--                            </v-expansion-panels>-->

                        </v-list-item-content>

                    </v-list-item>
                    <div class="pl-8 pb-5">
                        <div style="font-size: 16px; z-index: 2; font-family: S-CoreDream-4Regular">
                            8학년 Day school | English (Writing)
                        </div>
                        <div class="py-2"></div>
                        <div style="font-size: 14px; z-index: 2; font-family: S-CoreDream-4Regular">
                            안녕하세요! 8학년 학생입니다. 8학년부터 학교 수업에서 Essay를 쓰게되면서부터 항상 A받던 English 수업 성적이 확 떨어졌어요.ㅜㅜ 아이비에드
                            과외선생님한테 Essay structure, sentence structure 등 구조적인 거 배우고, 같이 에세이 첨삭해주시고, 책도 같이 읽고 하다보니
                            writing 점수가 올랐어요. 너무 감사해요!!
                        </div>
                    </div>
                </v-card>
            </div>
        </div>

    </div>
</template>

<script>
    export default {
        name: "ReviewPage7",
        mounted() {
            window.addEventListener("scroll", this.reveal);
        },
        destroyed() {
            window.removeEventListener("scroll", this.reveal);
        },
        methods: {
            reveal() {
                var reveals = document.querySelectorAll(".reveal");

                for (var i = 0; i < reveals.length; i++) {
                    var windowHeight = window.innerHeight;
                    var elementTop = reveals[i].getBoundingClientRect().top;
                    var elementVisible = 150;

                    if (elementTop < windowHeight - elementVisible) {
                        reveals[i].classList.add("active");
                    } else {
                        reveals[i].classList.remove("active");
                    }
                }
            },
        },
    };
</script>

<style>

    body {
        /*background: #42455a;*/
    }

    section {
        /*min-height: 100vh;*/
        /*display: flex;*/
        /*justify-content: center;*/
        /*align-items: center;*/
    }

    .each-title {
        font-size: 21px !important;
        text-align: left !important;
    }

    section:nth-child(1) {
        color: black;
    }

    section:nth-child(2) {
        color: black;
        background: #ffffff !important;
    }

    /* Add more styles for other sections as needed */
    section .container {
        /*margin: 100px;*/
        background-color: #ffffff !important;

    }

    section h1 {
        /*font-size: 3rem;*/
        /*margin: 20px;*/
    }

    section h2 {
        font-size: 40px;
        /*text-align: center;*/
        text-transform: uppercase;
    }

    section .text-container {
        display: flex;
        padding: 20px;
        margin-top: 10px;
    }

    section .text-container .text-box {
        /*margin: 20px;*/
        /*padding: 20px;*/
        /*background: #00c2cb;*/

    }

    section .text-container .text-box h3 {
        font-size: 30px;
        /*text-align: center;*/
        text-transform: uppercase;
        margin-bottom: 10px;
    }

    @media (max-width: 900px) {
        section h1 {
            font-size: 2rem;
            /*text-align: center;*/
        }

        section .text-container {
            flex-direction: column;
        }
    }

    .reveal {
        position: relative;
        transform: translateY(150px);
        opacity: 0;
        transition: 1s all ease;
    }

    .reveal.active {
        transform: translateY(0);
        opacity: 1;
    }
</style>

